/**
 * La barra de «Analizando…» de la ficha del parte (28-09-2026), sin React: cuánto
 * enseñar y qué frase toca. La IA no dice cuánto le falta, así que es una estimación
 * que sube rápido y se frena (1 − e^(−t/τ)), sin pasar del 95 % hasta que llega el
 * resultado. Con los dos modelos a la vez se tarda ~15–20 s: a los 18 s, ~85 %.
 */
const TAU_S = 8;

/** Porcentaje estimado a los `s` segundos (0–95). */
export function progresoEstimado(s: number): number {
  return Math.min(95, Math.max(0, Math.round(95 * (1 - Math.exp(-Math.max(0, s) / TAU_S)))));
}

/** Qué frase toca a los `s` segundos: analizando → mirando → comparando → ya casi. */
export function faseDelAnalisis(s: number): "p1" | "p2" | "p3" | "p4" {
  return s < 4 ? "p1" : s < 9 ? "p2" : s < 16 ? "p3" : "p4";
}
